// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__IzOmX","loginForm":"Login_loginForm__4GuL1","loginFieldIcon":"Login_loginFieldIcon__cwtsD","loginSubmit":"Login_loginSubmit__+7Aze"};